import { render, staticRenderFns } from "./OrderStatesPearls.vue?vue&type=template&id=16aefd4d&scoped=true&"
import script from "./OrderStatesPearls.vue?vue&type=script&lang=js&"
export * from "./OrderStatesPearls.vue?vue&type=script&lang=js&"
import style0 from "./OrderStatesPearls.vue?vue&type=style&index=0&id=16aefd4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16aefd4d",
  null
  
)

export default component.exports